import { css, keyframes } from 'styled-components';
import { transparentize } from 'polished';
import { baseShadowBlur } from './variables';

export const containerShadow = css`
    box-shadow: 0 0 ${baseShadowBlur} ${({ theme }) => transparentize(0.9, theme.palette.grayscale.black)};
`;

export const requiredAsterisk = css`
    :after {
        content: ' *';
        color: ${({ theme }) => theme.palette.danger.main};
    }
`;
export const requiredLabel = css`
    && {
        label {
            ${requiredAsterisk}
        }
    }
`;

export const fadeIn = keyframes`
    from {
        opacity: 0;
    }
    to {
        opacity: 1;
    }
`;
